/**
 * @description
 *
 * Функция возвращает данные в формате form-data
 * @param {any} object - объект, на основе которого создастся form-data
 *
 * @returns { FormData } -
 */
function getFormDataFromObject(object) {
  const requestFormData = new FormData()

  Object.entries(object).forEach(entry => {
    requestFormData.append(...entry)
  })

  return requestFormData
}

export default getFormDataFromObject
